/**
 * Friendly labels + Ant Tag colours for the new ORDER_STATUSES enum
 * defined in altcase-api/src/utils/constants.js.
 */

export const STATUS_LABEL = {
  ORDER_PLACED: 'Order Placed',
  AWAITING_CONFIRMATION: 'Awaiting Confirmation',
  PAYMENT_RECEIVED: 'Payment Received',
  PAYMENT_RECEIVED_STOCK_PENDING: 'Awaiting Stock',
  PARTIALLY_TRANSFERRED: 'Partially Transferred',
  SHARES_TRANSFERRED: 'Shares Transferred',
  COMPLETED: 'Completed',
  CANCELLED: 'Cancelled',
  OFFER_EXPIRED: 'Offer Expired',
};

export const STATUS_COLOR = {
  ORDER_PLACED: 'blue',
  AWAITING_CONFIRMATION: 'orange',
  PAYMENT_RECEIVED: 'blue',
  PAYMENT_RECEIVED_STOCK_PENDING: 'gold',
  PARTIALLY_TRANSFERRED: 'cyan',
  SHARES_TRANSFERRED: 'green',
  COMPLETED: 'green',
  CANCELLED: 'red',
  OFFER_EXPIRED: 'red',
};

export const STATUS_FILTER_OPTIONS = Object.entries(STATUS_LABEL).map(
  ([value, label]) => ({ label, value })
);

/** Prefer API display_label (trusted transfer-before-payment) over raw machine status. */
export const resolveOrderStatusLabel = (row) =>
  row?.display_label || STATUS_LABEL[row?.status] || row?.status || '—';

/** Tag colour: payment pending after transfer uses amber; else map by machine status. */
export const resolveOrderStatusColor = (row) => {
  if (row?.payment_pending) return 'gold';
  return STATUS_COLOR[row?.status] || 'default';
};
